import { clearLocalStorage, clearCookie } from '../../utils/clearStorage';

function daydiff(first, second) {
  var millisecondsPerDay = 24 * 60 * 60 * 1000;
  const dateFirst = new Date(first);
  return Math.round((second.getTime() - dateFirst.getTime()) / millisecondsPerDay);
}

export function localStorageClear(dateSelectedOn, dateToday) {
  var daysBetween = daydiff(dateSelectedOn, dateToday);
  if (daysBetween >= 365) {
    clearLocalStorage(['categoryClicked', 'categoryType', 'categoryPath', 'coreSelectedOn']);
    clearCookie(['categoryClicked', 'categoryType', 'categoryPath', 'coreSelectedOn']);
    return true;
  } else {
    return false;
  }
}

// console.log(daydiff(parseDate($('#first').val()), parseDate($('#second').val())));
